// Read with `useFeatureFlag` (app-payload, repo/org/user gated) — not `isFeatureEnabled`. Separate
// from RELATES_TO_FEATURE_FLAG so suggestions can be disabled without turning off the relationship.
export const RELATES_TO_SEMANTIC_SUGGESTIONS_FEATURE_FLAG = 'issues_relates_to_semantic_suggestions'
